<template  lang="pug">
  .time-picker-wrapper
    .time-picker(:class="{ 'flex-column': flex_column }")
      el-input.from(
        :size="flex_column ? 'mini' : 'default'",
        :class="{ errored: error.from }",
        v-mask="'##:##'",
        ref="from",
        v-model='internalTimeFrom',
        @blur="changeTimeRange('from')"
      )
      el-input.to(
        :size="flex_column ? 'mini' : 'default'",
        :class="{ errored: error.to }",
        v-mask="'##:##'",
        ref="to", v-model='internalTimeTo',
        @blur="changeTimeRange('to')"
      )
    .warning-message(v-if='this.error.from || this.error.to', append-to-body)
      span {{ $t(`End time has to be after start time. End time will be set to 24:00 and next day starting from 00:00 end ending at ${internalTimeTo}.`) }}
      el-button.float-right(type='success', size='mini', @click='adjustTime()')
        font-awesome-icon(icon="check")
</template>
<script>

export default {
  components: {},
  props: ['timeFrom', 'timeTo', 'flex_column'],
  data () {
    return {
      internalTimeFrom: this.timeFrom ? this.timeFrom : '00:00',
      internalTimeTo: this.timeTo ? this.timeTo : '24:00',
      error: {
        from: false,
        to: false
      }
    }
  },
  watch: {
    timeFrom: async function (newVal, oldVal) {
      this.internalTimeFrom = this.timeFrom
    },
    timeTo: async function (newVal, oldVal) {
      this.internalTimeTo = this.timeTo
    }
  },
  created () {
  },
  methods: {
    adjustTime () {
      this.$emit('adjustTime', this.internalTimeTo)
      this.internalTimeTo = '24:00'
      this.$refs['to'].blur()
    },
    setZeros () {
      this.internalTimeFrom = '00:00'
      this.internalTimeTo = '00:00'
      this.changeTimeRange('from')
      this.changeTimeRange('to')
    },
    changeTimeRange (whichInput) {
      if (
        this.__validateInput(this.internalTimeFrom) &&
        this.__validateInput(this.internalTimeTo) &&
        this.__validateValues()
      ) {
        this.$emit('change', this.internalTimeFrom, this.internalTimeTo)
        this.error[whichInput] = false
      } else {
        this.error[whichInput] = true
        this.$refs[whichInput].focus()
      }
    },
    __validateInput (timeValue) {
      const timeValueSplit = timeValue.split(':')
      if (timeValueSplit.length !== 2) return false
      if (timeValueSplit[0].length !== 2 || timeValueSplit[1].length !== 2) return false
      if (isNaN(parseInt(timeValueSplit[0])) || isNaN(parseInt(timeValueSplit[1]))) return false
      if (parseInt(timeValueSplit[0]) > 24 || parseInt(timeValueSplit[0]) < 0) return false
      if (parseInt(timeValueSplit[1]) > 59 || parseInt(timeValueSplit[1]) < 0) return false
      if (parseInt(timeValueSplit[0]) === 24 && parseInt(timeValueSplit[1]) > 0) return false
      return true
    },
    __validateValues () {
      const hourFrom = this.internalTimeFrom.split(':')[0]
      const hourTo = this.internalTimeTo.split(':')[0]
      if (hourFrom < hourTo) return true
      if (hourFrom > hourTo) return false
      const minutesFrom = this.internalTimeFrom.split(':')[1]
      const minutesTo = this.internalTimeTo.split(':')[1]
      if (minutesFrom <= minutesTo) return true
      return false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .time-picker-wrapper {
    position: relative;
    .warning-message {
      position: absolute;
      word-spacing: normal;
      width: 250px;
      text-align: left;
      background-color: $--color-primary-light-5;
      padding: 10px;
      margin: 0;
      border-radius: $--border-radius-base;
      border: $--border-extra-light;
      z-index: 100000000000;
    }
  }
  .error {
    padding: 0px 20px;
  }
  .danger {
    color: $--color-danger;
  }
  .to, .from {
    margin-right: 5px;
  }
  .time-picker {
    margin: auto;
    display: flex;
    .from, .to {
      &.errored {
        color: $--color-danger;
        // border: 1px solid $--color-danger;
      }
    }
    &.flex-column {
      display: flex;
      flex-direction: column;
    }
    .label {
      padding: 0px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/TimeRangeSelector.vue